declare var window: any;

// Export all the bootstrap components that we will be using,
// Might be cheaper file size wise to import only the module files if we are subsetting
export {
    Alert,
    Button,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Offcanvas,
    Popover,
    ScrollSpy,
    Tab,
    Toast,
    Tooltip,
} from 'bootstrap';

// Chart JS
// import {
//     Chart,
//     ArcElement,
//     LineElement,
//     BarElement,
//     PointElement,
//     BarController,
//     BubbleController,
//     DoughnutController,
//     LineController,
//     PieController,
//     PolarAreaController,
//     RadarController,
//     ScatterController,
//     CategoryScale,
//     LinearScale,
//     LogarithmicScale,
//     RadialLinearScale,
//     TimeScale,
//     TimeSeriesScale,
//     Decimation,
//     Filler,
//     Legend,
//     Title,
//     Tooltip,
//     SubTitle,
// } from 'chart.js';

// Chart.register(
//     ArcElement,
//     LineElement,
//     BarElement,
//     PointElement,
//     BarController,
//     BubbleController,
//     DoughnutController,
//     LineController,
//     PieController,
//     PolarAreaController,
//     RadarController,
//     ScatterController,
//     CategoryScale,
//     LinearScale,
//     LogarithmicScale,
//     RadialLinearScale,
//     TimeScale,
//     TimeSeriesScale,
//     Decimation,
//     Filler,
//     Legend,
//     Title,
//     Tooltip,
//     SubTitle,
// );

// import { Chart, registerables } from 'chart.js';
// Chart.register(...registerables);

// window.jQuery = jQuery;
// window.$ = jQuery;

import 'chart.js/dist/chart';

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

const onDOMContentLoaded = () => {
    // console.log('onDOMContentLoaded');

    // Remove loading class from body (discourages transitions during load)
    document.body.classList.remove('preload');
};

document.addEventListener('DOMContentLoaded', onDOMContentLoaded);

// console.log('loaded');
